// @flow
import React from "react";
import Clipboard from "clipboard";
import store from "../init/store.js";
import {setMatchmakingValue} from '../redux-actions/battle-actions'

class BattleLobbyShareLink extends React.Component {
  state: {
    isButtonLit: boolean
  };

  clipboard: any;

  constructor() {
    super();
    this.state = {
      isButtonLit: false
    };
  }

  autoClose() {
    //We've hit the COPY button, so fire this to close the modal.
    //Saves the user a click or tap.
    setMatchmakingValue({
      isLobbyInviteModalOpen: false
    })
  }

  getShareLink() {
    const currentRoomId = store.getState().matchmaking.currentRoomId;
    //Append a FROM name
    // const mainPlayerName = this.props.crewMembers[ Object.keys(this.props.crewMembers)[0] ].name;
    // const fromText = mainPlayerName ? `&f=${mainPlayerName}` : "";
    const fromText = ""; //TODO

    return `${window.location.origin}?online=y&p=${currentRoomId}${fromText}`;
  }

  handleCopyClick() {
    //Just needs a handler here for iOS. Otherwise button click doesnt submit
  }

  componentDidMount() {
    this.clipboard = new Clipboard(".js-copy-share-link-button");
    let self = this;

    //Copy Success
    this.clipboard.on("success", (e) => {
      // console.info('Action:', e.action);
      // console.info('Text:', e.text);
      // console.info('Trigger:', e.trigger);
      //alert('copied!')

      self.setState({ isButtonLit: true });
      setTimeout(() => {
        self.setState({ isButtonLit: false });

        this.autoClose();

      }, 600);

      e.clearSelection();
    });

    //Copy Fail
    this.clipboard.on("error", function(e) {
      console.error("Action:", e.action);
      console.error("Trigger:", e.trigger);
    });
  }

  componentWillUnmount() {
    //Destroy this instance of Clipboard
    this.clipboard.destroy();
  }


  getButtonStyle() {
    if (this.state.isButtonLit) {
      return {
        background: "#46C7AA",
        borderBottom: `0.3em solid #389C85`
      };
    }
    return {
      background: "#4990E2", //blue
      borderBottom: `0.3em solid #3F7FC9`
    };
  }

  render() {
    const buttonText = this.state.isButtonLit ? "Copied!" : "Copy Link";

    const style = {
      position: "relative"
      //overflow: "hidden"
    };
    const inputStyle = {
      display: "block",
      width: "100%",
      fontSize: "0.6em",
      height: "8em",
      textAlign: "center",
      marginBottom: "4em",
      border: "0.5em solid #B2AAB9",
      boxShadow: "0 0.3em 0 0 rgba(0,0,0,0.1)",
      color: "#200535"
      // position: "absolute",
      // left: "-999px"
    };

    return (
      <div style={style}>
        <input
          style={inputStyle}
          id="js-share-button-input"
          readOnly={true}
          value={this.getShareLink()}
        />
        <a
          className="js-copy-share-link-button button block large"
          data-clipboard-target="#js-share-button-input"
          onClick={this.handleCopyClick.bind(this)}
        >
          <span className="button--text">
            {buttonText}
          </span>
        </a>
      </div>
    );
  }
}

export default BattleLobbyShareLink;



// WEBPACK FOOTER //
// ./src/battle/BattleLobbyShareLink.js